import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { MappingSource } from 'src/components/admin/MappingsTable/utils/mappingsConstants';
import type { EncompassCustomField } from './getEncompassCustomFields';

export interface RegisteredCustomField {
  id: string;
  name: string;
  source: string;
  metadata: Omit<EncompassCustomField, 'id'>;
  updatedAt: string;
}

export default async function getRegisteredCustomFields(
  signal?: AbortSignal,
): Promise<RegisteredCustomField[]> {
  const http = await getCompatibleAuthTokenHttp();
  const response = await http<{
    externalFields: RegisteredCustomField[];
  }>(
    `/external-fields?source=${encodeURIComponent(MappingSource.EncompassCustomFields)}`,
    {
      method: 'GET',
      paginate: true,
      accumulateKey: 'externalFields',
      nextCursorKey: 'nextCursor',
      limit: 100,
      signal,
    },
  );
  if (!response.success || !Array.isArray(response.data?.externalFields))
    throw new Error('Failed to load saved custom fields');
  return response.data.externalFields;
}
